/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventResponseRecordsInnerEventShip
 */
export interface EventResponseRecordsInnerEventShip {
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEventShip
     */
    callsign?: string;
    /**
     * 
     * @type {number}
     * @memberof EventResponseRecordsInnerEventShip
     */
    cog?: number;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEventShip
     */
    destination?: string;
    /**
     * 
     * @type {number}
     * @memberof EventResponseRecordsInnerEventShip
     */
    draught?: number;
    /**
     * 
     * @type {Date}
     * @memberof EventResponseRecordsInnerEventShip
     */
    eta?: Date;
    /**
     * 
     * @type {number}
     * @memberof EventResponseRecordsInnerEventShip
     */
    heading?: number;
    /**
     * 
     * @type {number}
     * @memberof EventResponseRecordsInnerEventShip
     */
    imo?: number;
    /**
     * 
     * @type {number}
     * @memberof EventResponseRecordsInnerEventShip
     */
    mmsi?: number;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEventShip
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEventShip
     */
    navstatus?: string;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEventShip
     */
    shiptype?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof EventResponseRecordsInnerEventShip
     */
    size?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof EventResponseRecordsInnerEventShip
     */
    sog?: number;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEventShip
     */
    typeofmobile?: string;
}

/**
 * Check if a given object implements the EventResponseRecordsInnerEventShip interface.
 */
export function instanceOfEventResponseRecordsInnerEventShip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventResponseRecordsInnerEventShipFromJSON(json: any): EventResponseRecordsInnerEventShip {
    return EventResponseRecordsInnerEventShipFromJSONTyped(json, false);
}

export function EventResponseRecordsInnerEventShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResponseRecordsInnerEventShip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'callsign': !exists(json, 'callsign') ? undefined : json['callsign'],
        'cog': !exists(json, 'cog') ? undefined : json['cog'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        'draught': !exists(json, 'draught') ? undefined : json['draught'],
        'eta': !exists(json, 'eta') ? undefined : (new Date(json['eta'])),
        'heading': !exists(json, 'heading') ? undefined : json['heading'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'navstatus': !exists(json, 'navstatus') ? undefined : json['navstatus'],
        'shiptype': !exists(json, 'shiptype') ? undefined : json['shiptype'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sog': !exists(json, 'sog') ? undefined : json['sog'],
        'typeofmobile': !exists(json, 'typeofmobile') ? undefined : json['typeofmobile'],
    };
}

export function EventResponseRecordsInnerEventShipToJSON(value?: EventResponseRecordsInnerEventShip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'callsign': value.callsign,
        'cog': value.cog,
        'destination': value.destination,
        'draught': value.draught,
        'eta': value.eta === undefined ? undefined : (value.eta.toISOString()),
        'heading': value.heading,
        'imo': value.imo,
        'mmsi': value.mmsi,
        'name': value.name,
        'navstatus': value.navstatus,
        'shiptype': value.shiptype,
        'size': value.size,
        'sog': value.sog,
        'typeofmobile': value.typeofmobile,
    };
}

